import { svg } from '@phi/components';
import raw_light from './onshape-light.inline.svg';
import raw_dark from './onshape-dark.inline.svg';

export const OnshapeLogo = (light: boolean, l = raw_light, d = raw_dark) => svg(light ? l : d);
